<div class="date-picker-container">
    <button mat-stroked-button (click)="onPrevDay()" type="button">Prev</button>
    <mat-form-field class="element-input">
        <mat-label>Choose a date</mat-label>
        <input
            (dateChange)="onDateChange($event)"
            [ngModel]="selectedDate()"
            name="datepicker"
            [matDatepicker]="picker"
            matInput
            type="text" />
        <mat-datepicker-toggle matIconSuffix [for]="picker">
            <fa-icon icon="calendar-alt" />
        </mat-datepicker-toggle>
        <mat-datepicker #picker />
    </mat-form-field>
    <button mat-stroked-button (click)="onNextDay()" type="button">Next</button>
</div>
